var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#E0E2E7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 36,
    height: 36,
    rx: 18,
    stroke: "#F0F1F3",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 25C17.9477 25 17.5 25.4477 17.5 26C17.5 26.5523 17.9477 27 18.5 27H21.5C22.0523 27 22.5 26.5523 22.5 26C22.5 25.4477 22.0523 25 21.5 25H18.5Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 13C13.5 11.3431 14.8431 10 16.5 10H23.5C25.1569 10 26.5 11.3431 26.5 13V27C26.5 28.6569 25.1569 30 23.5 30H16.5C14.8431 30 13.5 28.6569 13.5 27V13ZM16.5 12H23.5C24.0523 12 24.5 12.4477 24.5 13V27C24.5 27.5523 24.0523 28 23.5 28H16.5C15.9477 28 15.5 27.5523 15.5 27V13C15.5 12.4477 15.9477 12 16.5 12Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.66ca4ad3cdce465dcd497691cdb1ac97.svg";
export { ForwardRef as ReactComponent };